import React from 'react';
import PropTypes from 'prop-types';

const H1Tag = ({ h1TagsEnabled, lastCategoryName }) => {
  if (!h1TagsEnabled || !lastCategoryName) {
    return null;
  }

  return (
    <h1 className="ht-h1CatalogueTag">
      {lastCategoryName}
    </h1>
  );
};

H1Tag.propTypes = {
  h1TagsEnabled: PropTypes.bool.isRequired,
  lastCategoryName: PropTypes.string,
};

export default H1Tag;
